import { jwtDecode } from "jwt-decode";

/**
 * /!\ Attention /!\ Certains tenants peuvent ne pas être disponibles pour l'utilisateur.
 * Il faut donc vérifier la liste des tenants disponibles avant de les utiliser
 * via tenantService.
 */
export type AccessTokenPayload = {
  /**
   * Liste des tenants auxquels l'utilisateur a accès.
   */
  tenantId?: string[];

  /**
   * ID du tenant par défaut.
   */
  defaultTenantId?: string;

  /**
   * Clés supplémentaires du payload.
   */
  [key: string]: unknown;
};

const isNonEmptyString = (v: unknown): v is string => typeof v === "string" && v.length > 0;

/**
 * Récupère le tenantId depuis le token.
 * - defaultTenantId (string)
 */
export const getTenantIdFromToken = (token: string | null | undefined): string | null => {
  if (!token) return null;

  try {
    const payload = jwtDecode<AccessTokenPayload>(token);

    if (isNonEmptyString(payload.defaultTenantId)) {
      return payload.defaultTenantId;
    }

    if (Array.isArray(payload.tenantId) && payload.tenantId.length > 0) {
      const firstTenant = payload.tenantId[0];
      return isNonEmptyString(firstTenant) ? firstTenant : null;
    }

    return null;
  } catch {
    return null;
  }
};

/**
 * Récupère la liste de tous les tenants disponibles depuis le token.
 * - tenantId (array) -> retourne l'array
 */
export const getAvailableTenantsFromToken = (token: string | null | undefined): string[] => {
  if (!token) return [];

  try {
    const payload = jwtDecode<AccessTokenPayload>(token);

    if (Array.isArray(payload.tenantId) && payload.tenantId.length > 0) {
      return payload.tenantId.filter(isNonEmptyString);
    }

    return [];
  } catch {
    return [];
  }
};
